import { render } from "./LaravelVueDatatablesGridContent.vue?vue&type=template&id=0f64c2d1"
import script from "./LaravelVueDatatablesGridContent.vue?vue&type=script&lang=js"
export * from "./LaravelVueDatatablesGridContent.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__